export class LeadsModel {
    id: number;
    organization: number;
    source_url: string;
    first_name: string;
    last_name: string;
    name: string;
    email: string;
    company: string;
    phone: string;
    designation: string;
    notes: string;
    creation_source: number;
    dbc: number;
    lead_owner: {
        id: number;
        first_name: string;
        last_name: string;
        email: string;
    };
    location: any;
    created: string;
    updated: string;

    constructor(json?) {
        if (!json) {
            return;
        }

        this.id = json['id'];
        this.organization = json['organization'];
        this.source_url = json['source_url'];
        this.first_name = json['first_name'];
        this.last_name = json['last_name'] ? json['last_name'] : '';
        this.name =
            json['first_name'] +
            ' ' +
            (json['last_name'] ? json['last_name'] : '');
        this.email = json['email'];
        this.company = json['company'];
        this.phone = json['phone'] ? json['phone'] : '';
        this.designation = json['designation'] ? json['designation'] : '';
        this.notes = json['notes'] ? json['notes'] : '';
        this.creation_source = json['creation_source'];
        this.dbc = json['dbc'];
        this.lead_owner = json['lead_owner'];
        this.location = json['location'];
        this.created = json['created'] || '';
        this.updated = json['updated'] || '';
    }
}
